import { useState } from 'react';
import { FAQ_ITEMS } from '../constants/content';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function FAQ() {
  const ref = useScrollAnimation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" ref={ref} className="fade-in mx-auto w-full max-w-4xl px-4 py-16 md:px-8">
      <h2 className="font-[Nunito] text-3xl font-extrabold text-[#5B3FA6] md:text-4xl">Common questions</h2>
      <div className="mt-8 space-y-3">
        {FAQ_ITEMS.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <article key={item.question} className="rounded-xl border border-[#EAE0D6] bg-white">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between px-5 py-4 text-left"
              >
                <span className="font-semibold text-[#4A3F66]">{item.question}</span>
                <span className="text-2xl text-[#5B3FA6]">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen ? <p className="px-5 pb-5 text-[#6F655E]">{item.answer}</p> : null}
            </article>
          );
        })}
      </div>
    </section>
  );
}
